//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CancelToken, AxiosRequestConfig, AxiosInstance } from 'axios';
import { BusinessObjectType } from '../../../Core/BusinessObjectType';
import DefaultDtoControllerProxy from './DefaultDtoControllerProxy';
import { IExchangeCompanyConfigurationDTO } from '../../../DTO/IExchangeCompanyConfigurationDTO';

//element.Name=ExchangeCompanyConfigurationController result.Name=ExchangeCompanyConfigurationController element.FullName=Digita.Tustena.UIApiControllers.BusinessObject.DTO.ExchangeCompanyConfigurationController);
/** WebApiController: ExchangeCompanyConfigurationController */
export class ExchangeCompanyConfigurationController extends DefaultDtoControllerProxy<IExchangeCompanyConfigurationDTO>
{
	constructor (axios: AxiosInstance)
	{
		super(axios, 'ExchangeCompanies', BusinessObjectType.ExchangeCompanyConfiguration);
	}
	public IsValidExchangeUrl(url: string, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<boolean>
	{
		return (this.axios.get('ExchangeCompanies/IsValidExchangeUrl?'+((url === null || url === undefined) ? '' : ('&url='+encodeURIComponent(url))), { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public DiscoverExchangeUrl(url: string, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<string>
	{
		return (this.axios.get('ExchangeCompanies/DiscoverExchangeUrl?'+((url === null || url === undefined) ? '' : ('&url='+encodeURIComponent(url))), { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public DiscoverAndValidateExchangeUrl(url: string, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<boolean>
	{
		return (this.axios.get('ExchangeCompanies/DiscoverAndValidateExchangeUrl?'+((url === null || url === undefined) ? '' : ('&url='+encodeURIComponent(url))), { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public ValidateCredentials(data: any, exchangeVersion: string, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<boolean>
	{
		return (this.axios.post('ExchangeCompanies/ValidateCredentials?'+((exchangeVersion === null || exchangeVersion === undefined) ? '' : ('&exchangeVersion='+encodeURIComponent(exchangeVersion))), data, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public DiscoverExchangeVersionFromUrl(data: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<string>
	{
		return (this.axios.post('ExchangeCompanies/DiscoverExchangeVersionFromUrl', data, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public DiscoverExchangeUsersWithDelegation(data: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any[]>
	{
		return (this.axios.post('ExchangeCompanies/DiscoverExchangeUsersWithDelegation', data, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetFull(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IExchangeCompanyConfigurationDTO>
	{
		return (this.axios.get('ExchangeCompanies/GetFull?&id='+id, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
}
